if ($('.where-to-buy').length > 0) {

    const searchInput = $('.where-to-buy .search-input');
    const resetButton = $('.where-to-buy .packages-reset');
    const searchButton = $('.where-to-buy .packages-search');
    const noResultsMessage = $('#noResultsMessage');
    let products = [];
    let isDataLoaded = false;

    let currentPage = 1;
    let itemsPerPage = 5;
    let maxVisiblePages = 4;

    let lastResults = [];
    
    searchInput.on('keyup', function (e) {
        if (e.which === 13 && searchInput.val() !== '') {
            searchButton.click();
        }
    })

    searchInput.on('blur', function (e) {
        searchInput.val(normalizeInput(searchInput.val(), false).toUpperCase());
    })

    searchButton.on('click', function(e) {
        e.preventDefault();
        searchInput.val(normalizeInput(searchInput.val(), false));
        searchByTypeNumber()
    })

    resetButton.on('click', function(e) {
        e.preventDefault();
        resetFilters();
    })

    function safeUpper(v) {
        return (v ?? "").toString().toUpperCase().trim();
    }

    async function fetchProducts() {
        try {
            const response = await fetch(`${window.location.origin + ctxPath}/.rest/buy-online/v1/search`);
            if (!response.ok) throw new Error(`Failed to load JSON: ${response.statusText}`);

            const data = await response.json();
            products = data.items;
            isDataLoaded = true;
            lastResults = [];
        } catch (error) {
            console.error("Error fetching product data:", error);
        }
    }

    fetchProducts().then(r => (console.log('fetching products')));

    function updateItemsPerPage() {
        itemsPerPage = parseInt(document.getElementById("itemsPerPageSelect").value, 10);
        currentPage = 1;

        if (lastResults.length > 0) {
            renderFromResults();
        } else {
            searchByTypeNumber();
        }
    }

    function gotoPage(pageNumber) {
        const totalPages = Math.ceil(lastResults.length / itemsPerPage);
        if (pageNumber < 1 || pageNumber > totalPages) return;

        currentPage = pageNumber;
        renderFromResults();
    }

    function updatePagination(totalResults) {
        const paginationContainer = document.querySelector(".pagination");
        paginationContainer.innerHTML = "";

        const totalPages = Math.ceil(totalResults / itemsPerPage);
        if (totalPages <= 1) return;

        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = startPage + maxVisiblePages - 1;

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        const firstPageBtnClass = currentPage <= 1 ? "disabled" : "";
        paginationContainer.innerHTML += `
      <li class="page-item ${firstPageBtnClass}">
        <a href="javascript:void(0);" class="page-link"
          onclick="if ('${firstPageBtnClass}' !== 'disabled') gotoPage(1)"
          ${firstPageBtnClass ? 'aria-disabled="true"' : ""}>&laquo;</a>
      </li>
    `;

        const prevPageBtnClass = currentPage <= 1 ? "disabled" : "";
        paginationContainer.innerHTML += `
      <li class="page-item ${prevPageBtnClass}">
        <a href="javascript:void(0);" class="page-link"
          onclick="if ('${prevPageBtnClass}' !== 'disabled') gotoPage(${currentPage - 1})"
          ${prevPageBtnClass ? 'aria-disabled="true"' : ""}>&lsaquo;</a>
      </li>
    `;

        for (let i = startPage; i <= endPage; i++) {
            paginationContainer.innerHTML += `
        <li class="page-item ${i === currentPage ? "active" : ""}">
          <a href="javascript:void(0);" class="page-link" onclick="gotoPage(${i})">${i}</a>
        </li>
      `;
        }

        const nextPageBtnClass = currentPage >= totalPages ? "disabled" : "";
        paginationContainer.innerHTML += `
      <li class="page-item ${nextPageBtnClass}">
        <a href="javascript:void(0);" class="page-link"
          onclick="if ('${nextPageBtnClass}' !== 'disabled') gotoPage(${currentPage + 1})"
          ${nextPageBtnClass ? 'aria-disabled="true"' : ""}>&rsaquo;</a>
      </li>
    `;

        const lastPageBtnClass = currentPage >= totalPages ? "disabled" : "";
        paginationContainer.innerHTML += `
      <li class="page-item ${lastPageBtnClass}">
        <a href="javascript:void(0);" class="page-link"
          onclick="if ('${lastPageBtnClass}' !== 'disabled') gotoPage(${totalPages})"
          ${lastPageBtnClass ? 'aria-disabled="true"' : ""}>&raquo;</a>
      </li>
    `;
    }

    function renderFromResults() {
        const resultsSection = document.querySelector(".results-section");
        const resultsCount = document.querySelector(".results-count");
        noResultsMessage.hide();

        if (lastResults.length === 0) {
            resultsSection.style.display = "none";
            noResultsMessage.show();
            document.getElementById("searchResults").innerHTML = "";
            document.querySelector(".pagination").innerHTML = "";
            return;
        }

        resultsSection.style.display = "block";

        document.querySelector(".results-container")?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });

        const start = Math.min((currentPage - 1) * itemsPerPage + 1, lastResults.length);
        const end = Math.min(currentPage * itemsPerPage, lastResults.length);

        resultsCount.innerText = `Showing results ${start} to ${end} of ${lastResults.length}`;

        displaySearchResults(
            lastResults.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
        );
        updatePagination(lastResults.length);
    }

    function searchByTypeNumber() {
        if (!isDataLoaded || products.length === 0) return;

        const rawQuery = document.getElementById("searchInput").value.trim();
        if (rawQuery === "") {
            resetFilters();
            return;
        }

        const q = normalizeInput(rawQuery, false).toUpperCase();

        const filteredProducts = products.filter(p => {
            const prod = p ?? {};

            const productCode = normalizeInput(prod.productCode, false).toUpperCase();
            const description = normalizeInput(prod.title, false).toUpperCase();
            const details = normalizeInput(prod.description, false).toUpperCase();

            const productOrderingCodes = Array.isArray(prod.orderingCodes)
                ? prod.orderingCodes
                : (prod.ordering_code ? [prod.ordering_code] : []);

            const productPartNumbers = Array.isArray(prod.partNumbers)
                ? prod.partNumbers
                : (prod.part_number ? [prod.part_number] : []);

            const orderingCodeMatches = productOrderingCodes.some(code => normalizeInput(code, false).toUpperCase().includes(q));
            const partNumberMatches = productPartNumbers.some(part => normalizeInput(part, false).toUpperCase().includes(q));

            const productMatches =
                productCode.includes(q) ||
                orderingCodeMatches ||
                partNumberMatches ||
                description.includes(q) ||
                details.includes(q);

            const distributors = Array.isArray(prod.distributors) ? prod.distributors : [];
            const distributorMatches = distributors.some(d => {
                const orderingCode = normalizeInput(d?.ordering_code, false).toUpperCase();
                const partNumber = normalizeInput(d?.part_number, false).toUpperCase();
                return orderingCode.includes(q) || partNumber.includes(q);
            });

            return productMatches || distributorMatches;
        });

        const statusPriority = {
            "PRODUCTION": 1,
            "TRANSFERRED": 2,
            "NOT FOR DESIGN IN": 3,
            "END OF LIFE": 4
        };

        filteredProducts.sort((a, b) => {
            const statusA = safeUpper(a?.productStatus);
            const statusB = safeUpper(b?.productStatus);
            return (statusPriority[statusA] || 5) - (statusPriority[statusB] || 5);
        });

        lastResults = filteredProducts;
        currentPage = 1;

        renderFromResults();
    }

    function displaySearchResults(results) {
        const searchResults = document.getElementById("searchResults");
        searchResults.innerHTML = "";

        results.forEach(product => {
            const prod = product ?? {};

            const status = (prod.productStatus ?? "").toString().trim();
            const statusUpperCase = safeUpper(status);
            let statusDotClass = "";

            if (statusUpperCase === "PRODUCTION") {
                statusDotClass = "green";
            } else if (statusUpperCase === "END OF LIFE") {
                statusDotClass = "red";
            } else if (statusUpperCase === "NOT FOR DESIGN IN") {
                statusDotClass = "yellow";
            } else if (statusUpperCase === "TRANSFERRED") {
                statusDotClass = "blue";
            } else {
                statusDotClass = "gray";
            }

            const sampleUrl = prod.requestSamples.length > 0 ? prod.requestSamples[0] : null;
            const salesItems = Array.isArray(prod.salesItems) ? prod.salesItems : [];
            const distributors = salesItems.flatMap(si => Array.isArray(si.distributors) ? si.distributors : []);

            const productCard = document.createElement("div");
            productCard.classList.add("product-card", "product-card-broad");

            productCard.innerHTML = `
        <div class="product-image">
          <img src="${prod.image ?? ""}" alt="${prod.title ?? ""}" loading="lazy">
        </div>
        <div class="product-content">
          <div class="product-title-wrapper">
            <a href="/pip/${prod.productCode}" class="product-title" aria-label="Product page for ${prod.productCode ?? ""}">${prod.productCode ?? ""}</a>
            <span class="status-label">– <span class="status-dot ${statusDotClass}"></span> ${statusUpperCase}</span>
          </div>
          <p class="product-description">${prod.title ?? ""}</p>
          <p class="product-details">${prod.description ?? ""}</p>
        </div>
        <div class="button-group">
          ${distributors.length > 0 ? `<a class="cta-button-details order-button" href="javascript:void(0);" onclick="toggleDistributorTable(event)">ORDER FROM DISTRIBUTORS</a>` : ""}
          ${sampleUrl ? `<a class="cta-button-details sample-button" href="${sampleUrl}" aria-label="Request samples of ${prod.name ?? ""}">REQUEST SAMPLES</a>` : ""}
        </div>
      `;

            productCard.innerHTML += createDistributorTable(prod);
            searchResults.appendChild(productCard);

            $('[data-toggle="tooltip"]').tooltip({container: 'body', html: false, trigger: 'hover'});
        });
    }

    function createDistributorTable(product) {
        if (!product) return "";

        const salesItems = Array.isArray(product.salesItems) ? product.salesItems : [];
        const tableRows = salesItems.flatMap(salesItem => {
            const itemDistributors = Array.isArray(salesItem.distributors) ? salesItem.distributors : [];
            return itemDistributors.map(d => `
          <tr>
            <td>${product.productCode ?? ""}</td>
            <td>${salesItem.orderingCode ?? ""}</td>
            <td>${salesItem.orderablePartNumber ?? ""}</td>
            <td>${d.name ?? ""}</td>
            <td><a href="${d.url ?? "#"}" target="_blank" rel="noopener noreferrer">Buy</a></td>
          </tr>
        `);
        });

        if (tableRows.length === 0) return "";

        return `<div class="table-responsive distributor-table" style="display: none;">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="header" data-toggle="tooltip" data-placement="top" title="The complete part number."><span>Type number</span></th>
              <th class="header" data-toggle="tooltip" data-placement="top" title="Ordering code (12NC): unique 12-digit numeric product identification code."><span>12NC</span></th>
              <th class="header" data-toggle="tooltip" data-placement="top" title="Orderable part number (OPN): unique number describing the product in a certain packing method. Use this number to order from our distributor partners."><span>OPN</span></th>
              <th class="header" data-toggle="tooltip" data-placement="top" title="Lists our distributors in each region."><span>Distributor</span></th>
              <th class="header" data-toggle="tooltip" data-placement="top" title="The easy, online way to order your Ampleon products."><span>Buy online</span></th>
            </tr>
          </thead>
          <tbody>
            ${tableRows.join('')}
          </tbody>
        </table>
      </div>`;
    }

    function toggleDistributorTable(event) {
        const card = event.target.closest(".product-card");
        const table = card ? card.querySelector(".distributor-table") : null;
        if (!table) return;
        table.style.display = table.style.display === "none" ? "block" : "none";
    }

    function resetFilters() {
        document.getElementById("searchInput").value = "";
        document.querySelector(".results-section").style.display = "none";
        document.getElementById("searchResults").innerHTML = "";
        document.querySelector(".pagination").innerHTML = "";
        document.querySelector(".results-count").innerText = "Showing results 1 to 5 of 0";
        noResultsMessage.hide();

        lastResults = [];
        currentPage = 1;
    }
}